import Content from "./page/Content";

function App() {
  return (
    <div className="app">
      <Content />
    </div>
  );
}

export default App;
